import { CardList } from "@blueprintjs/core"
import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const InstrumentsContainer = styled(FlexContainer)({
  marginTop: "20px",
})

export const HeaderContainer = styled(FlexContainer)({
  margin: "0 0 5px 10px",
})

export const InstrumentsCardList = styled(CardList)({
  marginBottom: "10px",
})
